import { useCallback, useEffect, useState } from 'react';
import { getDefaultPPAPaymentInfo } from 'api/ppaOnboarding';
import { IPaymentInfo } from 'types/common';

const useGetPPAPaymentInfo = (): [IPaymentInfo | undefined, boolean, string, () => Promise<void>] => {
    const [data, setData] = useState<IPaymentInfo | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const fetch = useCallback(async () => {
        setLoading(true);
        try {
            const res = await getDefaultPPAPaymentInfo();
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, error, fetch];
};

export default useGetPPAPaymentInfo;
